import React from 'react'
import common from '@/utils/common'
import moment from 'moment'
import { Text, TitleText, TitleWrapper } from '@/style-guide'
import { Card } from './Card'
import { Divider } from 'antd'
const formattedDate = (date: number) => {
  return moment.unix(date).format('MMM D, YYYY [at] HH:mm A')
}
export const PaymentHistory = ({
  booking,
  trip,
}: {
  booking: any;
  trip: any;
}) => {
  const paymentHistory: any[] = booking?.paymentHistory || []
  const { tripPaymentType } = trip || {}

  const showPaymentHistory =
    tripPaymentType == 'pay' && paymentHistory && paymentHistory.length > 0

  if (!showPaymentHistory) {
    return null
  }

  return (
    <div>
      <Divider />
      <TitleText style={{ paddingBottom: 0 }}>Payment history</TitleText>
      <TitleWrapper>
        {paymentHistory.map((payment: any, index) => (
          <div key={`payment_${index}`} style={{ paddingTop: '10px' }}>
            <div style={{ paddingBottom: '10px' }}>
              <Text size={14}>
                {' '}
                {formattedDate(payment.paymentIntent.created)}
              </Text>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Card
                card={payment.paymentMethod}
                hideName={true}
              />
              <span style={{ float: 'right' }}>
                {common.toCurrency(payment.amount)}
              </span>
            </div>
          </div>
        ))}
      </TitleWrapper>
    </div>
  )
}
